"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PopoverBoundaryContext = (0, _react.createContext)({
  boundaryRef: null,
  globalBoundaryRef: null
});
const globalBoundaryRef = {
  current: null
};

/**
 * Defines limits for the Popover component.
 * Wrap your application on top level to define global bounds, for example root of the application
 * And also you can wrap some modal windows or other blocks, to define smaller bounds.
 * You should set globalBoundaryRef or boundaryRef of this context
 */
function PopoverBoundaryProvider({
  children
}) {
  const boundaryRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement(PopoverBoundaryContext.Provider, {
    value: {
      boundaryRef,
      globalBoundaryRef
    }
  }, children);
}
var _default = exports.default = {
  Provider: PopoverBoundaryProvider,
  Consumer: PopoverBoundaryContext.Consumer,
  Context: PopoverBoundaryContext
};